import { render } from "./HiList.vue?vue&type=template&id=4a17d274"
import script from "./HiList.vue?vue&type=script&lang=js"
export * from "./HiList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__